import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import MetricCard from './MetricCard';

const MetricsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '12px',
  marginBottom: '16px',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    marginBottom: '20px'
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    marginBottom: '24px'
  },
  [theme.breakpoints.up('lg')]: {
    gap: '20px',
    marginBottom: '28px'
  },
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(5, 1fr)'
  }
}));

const MetricsGrid = ({ performanceMetrics, onMetricClick }) => {
  const metrics = [
    {
      id: 'localViews',
      title: 'Local Views',
      value: performanceMetrics.localViews,
      change: performanceMetrics.localViewsChange
    },
    {
      id: 'callsFromGBP',
      title: 'Calls from GBP',
      value: performanceMetrics.callsFromGBP,
      change: performanceMetrics.callsFromGBPChange
    },
    {
      id: 'directionRequests',
      title: 'Direction Requests',
      value: performanceMetrics.directionRequests,
      change: performanceMetrics.directionRequestsChange
    },
    {
      id: 'websiteClicks',
      title: 'Website Clicks',
      value: performanceMetrics.websiteClicks,
      change: performanceMetrics.websiteClicksChange
    },
    {
      id: 'newReviews',
      title: 'New Reviews',
      value: performanceMetrics.newReviews,
      change: performanceMetrics.newReviewsChange
    }
  ];

  return (
    <MetricsContainer>
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          title={metric.title}
          value={metric.value}
          change={metric.change}
          onClick={() => onMetricClick && onMetricClick(metric.id, metric.title)}
        />
      ))}
    </MetricsContainer>
  );
};

export default MetricsGrid;